<app-complex-modal-template
    class="flex flex-col"
    [isConfirmationMode]="false"
    (onClickEvent)="closeModal()">
    @switch (currentStep()) {
        @case (SaveEditModeSteps.CONFIRM) {
            <div class="flex flex-col">
                <fa-icon
                    class="flex justify-center grow"
                    size="5x"
                    [class]="hasConflicts ? 'text-on-error' : 'text-secondary'"
                    [icon]="['fat', 'circle-exclamation']" />
                <p class="!my-6 text-xl text-center text-black">
                    {{
                        title()
                            | transloco
                                : {
                                      deletedEntityCount: editConflicts?.deletedEntities?.length,
                                      modifiedEntityCount: editConflicts?.modifiedEntities?.length,
                                  }
                    }}
                </p>
                @if (hasConflicts && !hasDeletedDeposits) {
                    <div class="flex flex-row justify-around">
                        @if (usersModifiedEntitiesConflict().length) {
                            <app-custom-menu
                                label="usersWhoModified"
                                [menuOptions]="usersModifiedEntitiesConflict()" />
                        }
                        @if (usersDeletedEntitiesConflict().length) {
                            <app-custom-menu
                                label="usersWhoDeleted"
                                [menuOptions]="usersDeletedEntitiesConflict()" />
                        }
                    </div>
                }
                <p
                    class="text-center"
                    mat-dialog-content>
                    {{ 'editMode.submit.saveModalDescription' | transloco }}

                    {{
                        (this.modifiedLayerEditCount() === 1 && !!this.modifiedLayerName()
                            ? 'editMode.submit.saveModalDescriptionLayerEditCounts'
                            : 'editMode.submit.saveModalDescriptionEditCounts'
                        )
                            | transloco
                                : {
                                      entityCount: modifiedEntityEditCount(),
                                      layerCount: modifiedLayerEditCount(),
                                      layerName: modifiedLayerName(),
                                  }
                    }}
                </p>
                <div class="flex justify-center">
                    <app-button
                        [icon]="['fas', 'arrow-down-to-line']"
                        [label]="'exportModificationList' | transloco"
                        [loading]="isExportLoading()"
                        [type]="ButtonType.SECONDARY"
                        (onClick)="exportInXlsx(false)" />
                </div>
            </div>

            <div
                class="flex mt-2 p-4"
                mat-dialog-actions>
                @if (data.canEndEditSession) {
                    <app-button
                        class="mr-auto"
                        [label]="'editMode.submit.saveAndContinue' | transloco"
                        [type]="hasConflicts ? ButtonType.ALERT_SECONDARY : ButtonType.SECONDARY"
                        (onClick)="
                            save(SaveEditModeResultEnum.SAVED_CONTINUE, {
                                errorSnackKey: 'editMode.saveError',
                                keepEditSessionOpen: true,
                                successSnackKey: 'editMode.saveSuccess',
                            })
                        " />
                }
                <app-button
                    iconSize="sm"
                    [label]="(data.canEndEditSession ? 'editMode.submit.saveAndQuit' : 'save') | transloco"
                    [type]="hasConflicts ? ButtonType.ALERT : ButtonType.PRIMARY"
                    (onClick)="
                        data.canEndEditSession
                            ? save(SaveEditModeResultEnum.SAVED_QUIT, {
                                  errorSnackKey: 'editMode.saveError',
                                  keepEditSessionOpen: false,
                                  successSnackKey: 'editMode.saveSuccess',
                              })
                            : saveOnly()
                    " />
            </div>
        }
        @case (SaveEditModeSteps.SAVING) {
            <app-loading
                customMessage="editMode.submit.savingChanges"
                [hasMessage]="true" />
        }
        @default {
            <div class="flex flex-col">
                <fa-icon
                    class="flex justify-center grow text-secondary"
                    size="5x"
                    [icon]="['fat', 'circle-exclamation']" />
                <p class="!my-6 text-xl text-center text-black">
                    {{ 'editMode.submit.resumeModalTitle' | transloco }}
                </p>
                <p
                    class="text-center"
                    mat-dialog-content>
                    {{ 'editMode.downloadResult' | transloco }}
                </p>
                <div class="flex justify-center">
                    <app-button
                        [icon]="['fas', 'arrow-down-to-line']"
                        [label]="'editMode.exportResult' | transloco"
                        [loading]="isExportLoading()"
                        [type]="ButtonType.SECONDARY"
                        (onClick)="exportInXlsx(true)" />
                </div>
            </div>

            <div class="flex justify-end mt-2 p-4">
                <app-button
                    iconSize="sm"
                    [label]="'close' | transloco"
                    [type]="ButtonType.PRIMARY"
                    (onClick)="closeModal()" />
            </div>
        }
    }
</app-complex-modal-template>
